import { createActionFactory, Feature } from '../../shared';
import { debouncedSerializeAndPersistPeopleHubOptions } from './persistDataActions';
import type { Dispatch } from 'redux';
import type BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

export const leftPaneWidthUpdatedAction = createActionFactory<{ newWidth: number }>(
    'LeftPaneWidthUpdatedAction',
    Feature.LayoutManagement
);

export const listWidthUpdatedAction = createActionFactory<{ newWidth: number }>(
    'ListWidthUpdatedAction',
    Feature.LayoutManagement
);

export const getWidthOnWindowResizeCompletedAction = createActionFactory<{
    BrowserWidthBucket: BrowserWidthBucket;
}>('getWidthOnWindowResizeCompletedAction', Feature.LayoutManagement);

export const updateRightPaneStatusCompletedAction = createActionFactory<{ showRightPane: boolean }>(
    'UpdateRightPaneStatusCompletedAction',
    Feature.LayoutManagement
);

export const updateshowHublistStatusCompletedAction = createActionFactory<{ showHubList: boolean }>(
    'UpdateshowHublistStatusCompletedAction',
    Feature.LayoutManagement
);

export const updateLeftNavStateOnResize = createActionFactory<{
    leftNavVisible: boolean;
}>('UpdateLeftNavStateOnResize', Feature.LayoutManagement);

export const updateTabletFlagStatus = createActionFactory<{
    isTablet: boolean;
}>('UpdateTabletFlagStatus', Feature.LayoutManagement);

export const leftPaneWidthUpdated = (dispatch: Dispatch) => (newWidth: number) => {
    dispatch(leftPaneWidthUpdatedAction({ newWidth }));
    debouncedSerializeAndPersistPeopleHubOptions(dispatch);
};

export const listWidthUpdated = (dispatch: Dispatch) => (newWidth: number) => {
    dispatch(listWidthUpdatedAction({ newWidth }));
    debouncedSerializeAndPersistPeopleHubOptions(dispatch);
};

export const widthBucketUpdated = (dispatch: Dispatch) => (
    BrowserWidthBucket: BrowserWidthBucket
) => {
    dispatch(getWidthOnWindowResizeCompletedAction({ BrowserWidthBucket }));
};

export const updateRightPaneStatus = (dispatch: Dispatch) => (showRightPane: boolean) => {
    dispatch(updateRightPaneStatusCompletedAction({ showRightPane }));
};

export const updateShowHubListStatus = (dispatch: Dispatch) => (showHubList: boolean) => {
    dispatch(updateshowHublistStatusCompletedAction({ showHubList }));
};
export const updateLeftNavVisibility = (dispatch: Dispatch) => (leftNavVisible: boolean) => {
    dispatch(updateLeftNavStateOnResize({ leftNavVisible }));
};

export const updateTabletFlag = (dispatch: Dispatch) => (isTablet: boolean) => {
    dispatch(updateTabletFlagStatus({ isTablet }));
};

export type { Action } from '../../shared';
